import React from 'react';
import OccurrenceTypeFormPageContainer from './OccurrenceTypeFormPageContainer';

export class OccurrenceTypeFormPage extends React.Component {
    render() {
        return (
            <OccurrenceTypeFormPageContainer {...this.props} />
        )
    }
}